import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import checkImg from "../../assets/images/check_circle.svg";
import { LoginValue } from "../../Actions/LoginPageAction";
import { useDispatch, useSelector } from "react-redux";
import "./MFALogin.css";
import { setProgress } from "../../Actions/progressAction";
import { resetRememberDeviceState } from "../../reducers/RememberDeviceReducer";
import PropTypes from "prop-types";
import {
  verifyBackupCode,
  saveBackupRememberDevice,
  resetBackupLoginState,
} from "../../Actions/BackupLoginActions";

const BackupLogin = ({ onCancel }) => {
  const [code, setCode] = useState("");
  const dispatch = useDispatch();
  const verifyButtonRef = useRef(null);
  const rememberDeviceCheck = useSelector(
    (state) => state.rememberDevice.rememberDeviceCheck
  );
  const { isVerified, isLoading, errorMessage } = useSelector(
    (state) => state.backupLogin
  );
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  useEffect(() => {
    if (!showSuccessDialog) {
      dispatch(setProgress(60));
    } else {
      dispatch(setProgress(100));
    }
  }, [dispatch, showSuccessDialog]);

  const handleBackupCodeVerification = () => {
    if (!code || code.length !== 6) {
      return dispatch({
        type: "BACKUP_CODE_VERIFY_ERROR",
        payload: !code
          ? "Please enter the verification code."
          : "Please enter a 6-digit code.",
      });
    }
    dispatch(verifyBackupCode(code));
  };

  const handleNext = async () => {
    try {
      if (rememberDeviceCheck) {
        await dispatch(saveBackupRememberDevice());
      }
      setShowSuccessDialog(true);
    } catch (error) {
      setShowSuccessDialog(true);
    }
  };


  useEffect(() => {
    if (showSuccessDialog) {
          setTimeout(() => {
        document.getElementById("doneemailbackup").focus();
      }, 200);
    }
  }, [showSuccessDialog]);

  useEffect(() => {
  setTimeout(() => {
    const nextBtn = document.getElementById("nextbtnten");
    if (nextBtn) {
      nextBtn.focus();
    }
  }, 200);
}, [isVerified]);

  const handleDone = () => {
    localStorage.setItem("isMFACompleted", "true");
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("lastPath", "/dashboard");
    dispatch(LoginValue(true));
    dispatch(resetRememberDeviceState());
    dispatch(resetBackupLoginState());
  };
useEffect(() =>{
    setTimeout(() => {
      const verifyInput = document.getElementById("verifyBackupCode");
      verifyInput?.focus();
    }, 1500);
  },[])
  return (
    <>
      {!showSuccessDialog ? (
        <>
          <div className="dialog-content emailDailog_wrapper" role="group" aria-labelledby="backupcode">
            <p id="backupcode" className="detailine plc-text">Let’s set up your account via backup code.</p>
            <div className="authenticator-input">
              <div className="label-text">Backup Code</div>
              <div className="align">
                <input
                  type="text"
                  className="text-box"
                  value={code}
                  onChange={(e) => {
                    setCode(e.target.value);
                    dispatch(resetBackupLoginState());
                  }}
                    id="verifyBackupCode"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      verifyButtonRef.current.focus();
                      handleBackupCodeVerification();
                    }
                  }}
                  maxLength="6"
                />
                <div className="send-code-button">
                  <Button
                    color="primary"
                    className="btn-text"
                    ref={verifyButtonRef}
                    onClick={handleBackupCodeVerification}
                    disabled={isLoading}
                    disableRipple
                  >
                    Verify
                  </Button>
                </div>
              </div>
               <div aria-live="assertive" style={{ marginTop: "20px" }}>
              {isVerified && (
                <div style={{ color: "green", marginTop: "20px" }}>
                  Backup code verification successful!
                </div>
              )}
              {errorMessage && (
                <div
                  style={{
                    color: "red",
                    marginTop: "20px",
                    width: "max-content",
                  }}
                >
                  {errorMessage}
                </div>
              )}
              </div>
            </div>
          </div>
          <div className="mfa-save">
            <Button
              variant="outlined"
              className="cancelBtn"
              onClick={() => {
                dispatch(resetRememberDeviceState());
                dispatch(resetBackupLoginState());
                onCancel();
              }}
              disableRipple
            >
              Cancel
            </Button>
            <Button
              color="primary"
              className="disabled-button"
              disabled={!isVerified}
              onClick={() => handleNext()}
              id="nextbtnten"
              disableRipple
            >
              Next
            </Button>
          </div>
        </>
      ) : (
        <div className="succes_modal">
          <img src={checkImg} alt="" />
          <h2>Success</h2>
          <p id="verificationdone">Your verification is successfully completed.</p>
          <div className="mfa-save">
            <Button
              variant="contained"
              color="primary"
              onClick={handleDone}
              className="done-btn"
                 id="doneemailbackup"
              disableRipple
            >
              Done
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

BackupLogin.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default BackupLogin;
